define('util/browserDetection',[
    'jquery',
    'services/loggingService'
], function (
    $,
    loggingService
) {
    "use strict";

    //!!!!!!!!!!!
    // WARNING !!
    //!!!!!!!!!!!
    //
    // Parsing the User Agent string is, in general, a bad practice.  When possible, feature
    //   detection should be used instead.  An appropriate use case for User Agent parsing is to
    //   warn users about bugs that may exist in particular browser versions that have no other
    //   means of being detected than by way of the User Agent string.  Only add code to  this
    //   file if there is no other appropriate mechanism to detect the features that you require.

    var browserDetection = {};
    browserDetection.flags = {};

    //===============================================================
    // Firefox Flexbox Bugs
    //===============================================================
    //
    // There are two types of flexbox bugs in versions of firefox that cannot be detected (to
    //   my knowledge) by any other mechanism than User Agent parsing.  There is a MAJOR bug
    //   and a MINOR bug.
    //
    // The "Major" flex bug has no work-arounds and causes exponential degradation in
    //   performance in views heavily using flexbox.  The user should be warned to use an
    //   upgraded version of firefox or another browser if a particular area of the app is
    //   affected. Not all views are affected, only those with heavy flexbox UIs.
    //
    //   The relevant mozilla issue can be referenced here:
    //     https://bugzilla.mozilla.org/show_bug.cgi?id=1141108
    //
    // The "Minor" flex bug does have a work-around.  Most often setting the following CSS
    //   to flex items will correct the cripplingly slow rendering behavior:
    //     ```
    //     min-height: 0px; // Use any "definite" value here (any `px`, but not `auto` or a `%`).
    //     min-width: 0px;  // Same here
    //     ```
    // The other work-around involves absolutely positioned elements that are also flex items.
    //   For some reason (which is as of the time of this writing still unknown to the mozilla
    //   devs) you need a wrapper div with the above definite `min-height` and `min-width` style
    //   values around any relatively positioned elements.  So for example:
    //     ```
    //     <div style="position: relative;">
    //       <div style="position: absolute;">
    //       </div>
    //     </div>
    //     ```
    //   would need a wrapper around the relatively positioned element (not the absolute positioned
    //   one like one might think), like so:
    //     ```
    //     <div style="min-height: 0px; min-width: 0px;">
    //       <div style="position: relative;">
    //         <div style="position: absolute;">
    //         </div>
    //       </div>
    //     </div>
    //     ```
    //   The relevant mozilla issue can be referenced here:
    //     https://bugzilla.mozilla.org/show_bug.cgi?id=1150123
    //
    var parseForFirefoxFlexboxBugs = function (ua) {
        var firefoxRe = /firefox\/[^ ]*/i;
        var match = ua.match(firefoxRe);
        if (!match) {
            return;
        }
        var split = match[0].split('/');
        if (!(split && split.length > 1)) {
            return;
        }
        // parseFloat grabs the number out of strings that begin with number characters but
        //   have non-numeric characters after the number chars (e.g. "37.0a" parses to 37.0).
        var version = parseFloat(split[1]);

        // MAJOR bug - This bug is present at least back to firefox version 30.0
        browserDetection.flags.hasMajorFirefoxFlexBug = (version < 38.0);

        // MINOR bug (Firefox has not yet pushed a fix for this particular bug.  When a fix is
        //   added, then a maximum upper-bound on the version should be added here.
        browserDetection.flags.hasMinorFirefoxFlexBug = (version >= 38.0);

        // Adds an attr to the html DOM element to signify that the MAJOR or MINOR bug versions
        //   were detected.  The intention here is to provide a means to use CSS selectors and
        //   change the CSS based on the existence of the bugs.  One example is that you may be
        //   able to use the old `-moz-box` 2009 flexbox specification to avoid this bug.  This
        //   does work fine, but the old spec does not have all of the new features that the
        //   current flex-box implementation does, so it may not be sufficient in all scenarios.
        if (browserDetection.flags.hasMajorFirefoxFlexBug) {
            $('html').attr('data-firefox-major-flex-bug', true);
            loggingService.warn("MAJOR flexbox bug detected - A version of firefox was detected that has a known MAJOR rendering bug related to flexbox usage.  This can make the UI unusable in flexbox heavy views.  There IS NOT a known work-around, so the user should be notified where appropriate.");
        }
        if (browserDetection.flags.hasMinorFirefoxFlexBug) {
            $('html').attr('data-firefox-minor-flex-bug', true);
            loggingService.warn("MINOR flexbox bug detected - A version of firefox was detected that has a known MINOR rendering bug related to flexbox usage.  This can make the UI unusable in flexbox heavy views, but there IS a known work-around.");
        }

    };
    parseForFirefoxFlexboxBugs(navigator.userAgent);

    return browserDetection;
});
